<template>
</template>

<script lang="ts" type="text/tsx">
import VConsole from 'vconsole';

import { DataInterface } from '@interface/public';

export default {
  name: 'test',
  data(): DataInterface {
    return {
      instance: {
        console: null
      }
    };
  },
  mounted(): void {
    this.init();
  },
  methods: {
    /**
     * 初始化
     */
    init(): void {
      const name = 'vConsole_switch_',
        margin = 20;
      
      localStorage.setItem(`${ name }x`, margin.toString());
      localStorage.setItem(`${ name }y`, margin.toString());
      
      this.instance.console = new VConsole({
        theme: 'dark',
        disableLogScrolling: true
      });
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}public/';

</style>